import { useCallback, useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

export type CollapsedSections = {
  readonly isCollapsed: (sectionId: string) => boolean;
  readonly toggle: (sectionId: string) => void;
};

export const useCollapsedSections = (): CollapsedSections => {
  const storage = useServerStorage('user');

  const collapsedSectionIds = useMemo(
    () => storage.data.team?.collapsedSectionIds ?? [],
    [storage.data.team?.collapsedSectionIds],
  );

  const isCollapsed = useCallback(
    (sectionId: string) => collapsedSectionIds.includes(sectionId),
    [collapsedSectionIds],
  );

  const toggle = useCallback(
    (sectionId: string) => {
      storage.set({
        team: (draft) => {
          const ids = draft.collapsedSectionIds ?? [];
          draft.collapsedSectionIds = ids.includes(sectionId)
            ? ids.filter((id) => id !== sectionId)
            : [...ids, sectionId];
        },
      });
    },
    [storage],
  );

  return useMemo(() => ({ isCollapsed, toggle }), [isCollapsed, toggle]);
};
